/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Payroll {
    angular.module("meevo.plugins.payroll", []);
}